import { Button } from '@/Components/UI/Button/Button';
import Icon from '@/Components/UI/Icon/Icon';
import Popover from '@/Components/UI/Popover/Popover';
import { showModal } from '@/redux/reducers/modalsSlice';
import {
  MODAL_CREATE_FOLDER,
  MODAL_DELETE_FILE,
  MODAL_EDIT_FILE,
  MODAL_SHARE_FILE,
} from '@/Utils/constants';
import { useDispatch } from 'react-redux';

const CurrentFolderMenu = ({
  filePath = [],
  sortingData = {},
  handleMoveFolder = () => {},
  isViewerAnalyst,
  isLiveQuery,
  canShareLiveQuery,
}) => {
  const dispatch = useDispatch();
  const renderMenuOptions = () => {
    const fullMenuOptions = [
      {
        name: 'Rename',
        icon: 'pencil-simple',
        action: { name: MODAL_EDIT_FILE, props: { refreshHeader: true } },
        popup: true,
      },
      {
        name: 'New Folder',
        icon: 'folder-plus',
        action: { name: MODAL_CREATE_FOLDER, props: { directory: sortingData.currentDirectory } },
        popup: true,
      },
      {
        name: 'Move',
        icon: 'arrows-out-cardinal',
        action: null,
        popup: false,
      },
      {
        name: 'Share',
        icon: 'user-plus',
        action: { name: MODAL_SHARE_FILE, props: {} },
        popup: true,
      },
      {
        name: 'Delete',
        icon: 'trash',
        action: {
          name: MODAL_DELETE_FILE,
          props: {
            filesToDelete: [filePath[filePath.length - 1]].map((e) => e?.metadata),
            resetLibrary: true,
          },
        },
        popup: true,
      },
    ];
    const liveQueryMenuOptions = [
      {
        name: 'Share',
        icon: 'user-plus',
        action: { name: MODAL_SHARE_FILE, props: {} },
        popup: true,
      },
    ];
    const viewerAnalystMenuOptions = [
      {
        name: 'Folder Properties',
        icon: 'info',
        action: { name: MODAL_EDIT_FILE, props: { refreshHeader: true } },
        popup: true,
      },
      {
        name: 'Move',
        icon: 'arrows-out-cardinal',
        action: null,
        popup: false,
      },
      {
        name: 'Share',
        icon: 'user-plus',
        action: { name: MODAL_SHARE_FILE, props: {} },
        popup: true,
      },
      {
        name: 'Delete',
        icon: 'trash',
        action: {
          name: MODAL_DELETE_FILE,
          props: {
            filesToDelete: [filePath[filePath.length - 1]].map((e) => e?.metadata),
            resetLibrary: true,
          },
        },
        popup: true,
      },
    ];

    const menuOptions = () => {
      if (isLiveQuery) {
        return liveQueryMenuOptions;
      } else if (isViewerAnalyst) {
        return viewerAnalystMenuOptions;
      } else {
        return fullMenuOptions;
      }
    };

    return (
      <div className='flex flex-col w-48 gap-1 cursor-pointer'>
        {menuOptions().map(({ name, icon, action, popup }) => {
          return (
            <div
              key={name}
              className='flex items-center h-8 text-sm rounded cursor-pointer hover:bg-opacity-40'
            >
              <Button
                variant='ghost'
                iconName={icon}
                className='!w-full !text-left !justify-start !px-2 !gap-1 hover:!bg-opacity-30'
                onClick={() => (popup ? dispatch(showModal(action)) : handleMoveFolder())}
                dataCy={`file-path-dropdown__action-${name}`}
              >
                {name}
              </Button>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Popover
      isButtonIcon={false}
      isStatic={false}
      isCloseButton={false}
      panelClassname='max-w-fit ml-3 !p-1'
      buttonClassname={isLiveQuery && !canShareLiveQuery ? 'hidden' : 'w-6 !h-6 mt-[2px]'}
      renderComponent={(props) => renderMenuOptions(props)}
      dataCy='file-path-dropdown'
    >
      <Icon name='caret-down' color='#151515' size={16} />
    </Popover>
  );
};

export default CurrentFolderMenu;
